import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeightVariableDirective } from './height-variable.directive';

@NgModule({
  declarations: [
    HeightVariableDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HeightVariableDirective
  ]
})
export class HeightVariableModule { }
